import { render, staticRenderFns } from "./ViewProductsDetail.vue?vue&type=template&id=26896f50&"
import script from "./ViewProductsDetail.vue?vue&type=script&lang=js&"
export * from "./ViewProductsDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports